import { memo } from 'react';

function PlusIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			height="19"
			fill="none"
			viewBox="0 0 18 19"
			{...props}
		>
			<path
				stroke="#A6A6A6"
				strokeWidth="1.5"
				d="M4.281 9.297h9.438M9 4.578v9.437"
			></path>
		</svg>
	);
}

export default memo(PlusIcon);
